import styled from 'styled-components';
import { DEVICES } from '../../../config/appConfig';

export const StyledOverview = styled.div`
  padding-bottom: 60px;
  padding-top: 15px;
  scroll-margin-top: 220px; /* height of sticky header */
  &:before {
    content: '';
    display: block;
    height: 220px; /* fixed header height*/
    margin: -220px 0 0; /* negative fixed header height */
  }

  img {
    width: auto !important;
  }
  .title {
    padding: 25px 0px 15px 0px;
    text-align: center;
    line-height: 1.1;
  }
  p {
    text-align: left;
  }
`;

export const StyledContainer = styled.div`
  margin: 0rem;
  padding: 0 1rem;
  margin-left: auto;
  margin-right: auto;
  .overview-content {
    position: relative;
    .img-fluid {
      width: 40%;
      height: auto;
      max-width: 400px;
      object-fit: contain;
      display: block;
      @media ${DEVICES.tablet} {
        width: 50%;
        max-width: 350px;
        margin: 0 auto;
      }

      @media ${DEVICES.mobile} {
        width: 60%;
        max-width: 320px;
        margin: 0 auto;
      }

      @media ${DEVICES.sMobile} {
        width: 70%;
        max-width: 280px;
        margin: 0 auto;
      }

      @media ${DEVICES.sSMobile} {
        width: 80%;
        max-width: 250px;
        margin: 0 auto;
      }
    }
  }
  .overview-title {
    color: #010915;
    font-size: 1.5rem; // 24px
    font-style: normal;
    font-weight: 600;
    text-align: left;
    margin: 1.5rem 0 1.125rem; // 24px 0 18px

    @media ${DEVICES.sMobile} {
      font-size: 1.25rem; // 20px
      margin: 1rem 0;
    }
  }
`;

export const StyledFormContainer = styled.div`
  width: 50%;
  float: right;
  background: #fff;
  margin: -30% 10px 5px 10px;
  margin-top: -15rem;
  position: relative;
  border-radius: 7px;
  box-shadow: 0 0 33.5px 1px rgba(0, 0, 0, 0.04);
  height: auto;

  @media ${DEVICES.tablet}, ${DEVICES.mobile}, ${DEVICES.sMobile} {
    width: 100%;
    float: none;
    margin: -35% 0px 24px 0px;
    margin-top: -12rem;
  }
`;

export const StyledHeaderTitle = styled.div`
  float: left;
  position: absolute;
  margin-top: -130px;
  color: #fff;

  .header-page-title {
    color: white;
    font-weight: 500;
    font-size: 36px;
  }

  @media ${DEVICES.tablet}, ${DEVICES.mobile}, ${DEVICES.sMobile} {
    float: none;
    width: 100%;
    text-align: center;
    margin-top: -50px;

    .header-page-title {
      font-size: 1.3rem;
    }
  }
`;
